// extracted by mini-css-extract-plugin
export default {"Subheading":"SXKb5AgW"};